import Backbone from 'backbone';

export default Backbone.Model.extend({
	idAttribute: 'Id',

	defaults: {
		Id: '',
		IsHighlighted: false,
		IsSelected: false,
		Name: '',
		Symbol: ''
	}
});
